import {FloatingSelect} from './floating_select'
import {NonFloatingSelect} from './non_floating_select'

export const SelectComponent = ({
	ref,
	trigger,
	placement,
	width,
	maxWidth = 300,
	height,
	className,
	title,
	footerButtons,
	emptyPlaceholderProps,
	...providerProps
}) => {
	const sharedProps = {
		width,
		maxWidth,
		height,
		className,
		title,
		footerButtons,
		emptyPlaceholderProps,
	}

	if (!trigger) return <NonFloatingSelect sharedProps={sharedProps} {...providerProps} />

	return <FloatingSelect ref={ref} trigger={trigger} placement={placement} sharedProps={sharedProps} {...providerProps} />
}
